
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuth();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  // Don't show navbar on auth page
  if (location.pathname === '/auth') {
    return null;
  }

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/automaten', label: 'Automaten' },
    { path: '/lager', label: 'Lager' },
    { path: '/verkauf', label: 'Verkauf' },
    { path: '/finanzen', label: 'Finanzen' },
    { path: '/kontakte', label: 'Kontakte' },
    { path: '/dokumente', label: 'Dokumente' }
  ];

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/auth');
    setIsUserMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm border-b sticky top-0 z-40 w-full">
      <div className="w-full px-2 sm:px-4 lg:px-6">
        <div className="flex justify-between items-center h-12 sm:h-14">
          <div 
            className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 cursor-pointer hover:text-blue-600 transition-colors flex-shrink-0 min-w-0"
            style={{ fontFamily: '"Pacifico", serif' }}
            onClick={() => navigate('/dashboard')}
          >
            Dä Snäckomat Manager
          </div>
          
          <nav className="hidden lg:flex space-x-2 xl:space-x-4 flex-shrink-0">
            {menuItems.map((item) => (
              <div
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`px-2 py-1 rounded text-xs xl:text-sm font-medium cursor-pointer whitespace-nowrap transition-colors select-none ${
                  location.pathname === item.path
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                {item.label}
              </div>
            ))}
          </nav>
          
          <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
            <button
              onClick={toggleFullscreen}
              className="hidden lg:block p-2 text-gray-600 hover:text-gray-900 cursor-pointer flex-shrink-0 transition-colors"
              title={isFullscreen ? 'Vollbild verlassen' : 'Vollbild aktivieren'}
            >
              <i className={`${isFullscreen ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line'} w-5 h-5 flex items-center justify-center`}></i>
            </button>

            {user && (
              <div className="relative">
                <button
                  onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                  className="hidden lg:flex items-center space-x-2 p-2 text-gray-600 hover:text-gray-900 cursor-pointer transition-colors"
                >
                  <i className="ri-user-line w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm font-medium">{user.email}</span>
                  <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center"></i>
                </button>
                
                {isUserMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-50">
                    <button
                      onClick={handleSignOut}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
                    >
                      <i className="ri-logout-box-line w-4 h-4 flex items-center justify-center"></i>
                      <span>Abmelden</span>
                    </button>
                  </div>
                )}
              </div>
            )}
            
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-gray-600 hover:text-gray-900 cursor-pointer flex-shrink-0 transition-colors"
            >
              <i className="ri-menu-line w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-2 border-t border-gray-200">
            {menuItems.map((item) => (
              <div
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  setIsMobileMenuOpen(false);
                }}
                className={`block px-2 py-2 text-sm font-medium cursor-pointer transition-colors ${
                  location.pathname === item.path
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                {item.label}
              </div>
            ))}
            {user && (
              <div className="border-t border-gray-200 mt-2 pt-2">
                <div className="px-2 py-1 text-xs text-gray-500">
                  Angemeldet als: {user.email}
                </div>
                <button
                  onClick={handleSignOut}
                  className="w-full text-left px-2 py-2 text-sm text-gray-700 hover:text-blue-600 hover:bg-gray-50 flex items-center space-x-2"
                >
                  <i className="ri-logout-box-line w-4 h-4 flex items-center justify-center"></i>
                  <span>Abmelden</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}